<template>
  <div aria-live="polite" aria-atomic="true" class="_toaster">
    <transition-group name="toast">
      <div v-for="toast in toasts" :key="toast.id" class="toast show" :class="{[toast.type]: true}" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-header">
          <img class="rounded mr-2" >
          <strong class="mr-auto">{{ toast.title }}</strong>
          <button type="button" class="ml-4 mb-1 mt-1 close" data-dismiss="toast" aria-label="Close" @click="dismissToast(toast)">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="toast-body">
          {{ toast.text }}
        </div>
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
  ._toaster {
    position: fixed;
    top: 5px;
    right: 5px;
    min-height: 200px;
    z-index: 10000;
  }

  /* Transitions */

  .toast-enter-active,
  .toast-leave-active {
    max-height: 800px;
    transition: 0.3s ease;
    overflow: hidden;
  }
  .toast-enter-active {
    transition: max-height 1s ease;
  }
  .toast-leave-to {
    opacity: 0;
  }
  .toast-enter-from:not(:last-child) {
    max-height: 0;
    border-width: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0;
    opacity: 0;
  }

  /* Toast type styling */

  .error > * {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #721c24;
  }
</style>

<script>
  import { reactive } from 'vue';

  export default {
    data() {
      return {
        toasts: []
      }
    },
    methods: {
      showToast(toast) {
        const reactiveToast = reactive(toast);
        reactiveToast.id = Math.random();
        reactiveToast.title = toast.title || (toast.type == 'error' ? 'Une erreur est survenue !' : 'Information');
        this.toasts.unshift(reactiveToast);
        setTimeout(() => this.dismissToast(reactiveToast), 10000);
      },
      dismissToast(toast) {
        const i = this.toasts.indexOf(toast);
        this.toasts.splice(i, 1);
        if (toast.onDismiss && typeof toast.onDismiss == 'function') {
          toast.onDismiss();
        }
      },
    }
  }
</script>